module.exports = __webpack_public_path__ + "static/media/model-pathfinder-r50.69af5c2d.webp";